import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import ReactAudioPlayer from 'react-audio-player';

const QuestionContents = (props) => {
    const { t, i18n } = useTranslation()

    useEffect(() => {
    }, []);
    // URL'ye autoplay=0 ekliyoruz

    return (
        <div>
            {props.question['type'] === "sound" ? (
                <ReactAudioPlayer
                    src={props.question['url']}
                    controls
                />
            ) : (
                <div></div>
            )}
            {props.question['type'] === "video" ? (
                <video
                    width="640"
                    height="360"
                    controls
                    autoPlay={false}  // autoplay'i false yapıyoruz
                >
                    <source src={props.question['url']} type="video/mp4" />
                    Tarayıcınız video etiketini desteklemiyor.
                </video>
            ) : (
                <div></div>
            )}
            {props.question['type'] === "image_sound" ? (
                <div>
                    <img style={{ width: "200px" }} src={props.question['url']} />

                    <br />
                    <ReactAudioPlayer
                        src={props.question['soundUrl']}
                        controls
                    />
                </div>
            ) : (
                <div></div>
            )}
            {props.question['type'] === "image" ? (
                <div style={{ width: "70%", marginLeft: "auto", marginRight: "auto " }}>
                    <img style={{ width: "200px" }} src={props.question['url']} />
                </div>
            ) : (
                <div></div>
            )}
            <br />
        </div>

    );
};

export default QuestionContents;